import { copy } from "plos/src/styles/copy.css";
import { Trans } from "react-i18next";

const FixturesHelp = () => (
  <div className={copy}>
    <Trans ns="help" i18nKey="contextualHelp.fixtures.description">
      <p>
        This page shows upcoming Premier League matches organised by Gameweeks.
      </p>
      <p>
        Some fixtures are considered easier or harder based on team strength.
        You can consider fixture difficulty when selecting players or planning
        transfers, and the Fixture Difficulty Rating (FDR) shows this for each
        fixture when viewing a player profile. Select a player card in your team
        to view their profile.
      </p>
      <p>
        Occasionally, there may be Double Gameweeks, when a team plays twice, or
        Blank Gameweeks, when a team has no fixture in the Gameweek. These
        events can impact on Fantasy strategy and often influence when chips are
        played.
      </p>
    </Trans>
  </div>
);

export default FixturesHelp;
